import React from "react";
import { Modal } from "react-bootstrap";
import "./NonFuelProductHistoryModal.css";

const NonFuelProductHistoryModal = ({
  show,
  onHide,
  productName,
  loading,
  entries,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="nf-product-history-modal"
    >
      <Modal.Header className="modal-title">
        <h5 className="modal-title mb-0">Change History</h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        ></button>
      </Modal.Header>
      <Modal.Body>
        {productName && (
          <p className="nf-history-product-name mb-3">
            <strong>Product:</strong> {productName}
          </p>
        )}

        {loading && (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {!loading && entries.length === 0 && (
          <p className="text-muted mb-0">No change history found for this product.</p>
        )}

        {!loading && entries.length > 0 && (
          <div className="nf-history-list">
            {entries.map((entry) => (
              <div key={entry.id} className="nf-history-entry">
                <div className="nf-history-entry-header">
                  <span
                    className={`nf-history-badge nf-history-badge--${(
                      entry.operation || "UPDATE"
                    ).toLowerCase()}`}
                  >
                    {entry.operation === "INSERT" ? "Created" : "Updated"}
                  </span>
                  <span className="nf-history-meta">
                    {entry.changed_at} &middot; {entry.changed_by}
                  </span>
                </div>
                <div className="table-responsive">
                  <table className="table table-sm nf-history-table mb-0">
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Previous</th>
                        <th>New</th>
                      </tr>
                    </thead>
                    <tbody>
                      {entry.changes.map((change, index) => (
                        <tr key={`${entry.id}-${change.field}-${index}`}>
                          <td>{change.label}</td>
                          <td className="nf-history-old">
                            {change.old !== null && change.old !== undefined
                              ? change.old
                              : "—"}
                          </td>
                          <td className="nf-history-new">
                            {change.new !== null && change.new !== undefined
                              ? change.new
                              : "—"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default NonFuelProductHistoryModal;
